import React, { Component } from 'react';

class ReflexRuleBreadcrumb extends Component {
    render() {
        return (
            <div className="breadcrumb-bar">
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-md-12 col-12">
                            <nav aria-label="breadcrumb" className="page-breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Lab Hub
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Reflex Rules
                                    </li>
                                </ol>
                            </nav>
                            <h2 className="breadcrumb-title">
                                <i className="fas fa-code-branch mr-2"></i>
                                Reflex Rules
                            </h2>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ReflexRuleBreadcrumb;